import clsx from 'clsx';
import { useFormikContext } from 'formik';
import { useCallback } from 'react';
import React from 'react';
import { Button } from '../../../base-components/Button';
import styles from './ResetButton.module.scss';

interface Props {
    emptyFilterState: any;
    className?: string;
}

export const ResetButton: React.FC<Props> = ({
    emptyFilterState,
    className,
}) => {
    const { setValues } = useFormikContext();
    const resetForm = useCallback(() => {
        setValues(emptyFilterState);
    }, [emptyFilterState, setValues]);
    return (
        <Button
            variant="secondary"
            className={clsx(styles.button, className)}
            onClick={resetForm}
        >
            Сбросить фильтр
        </Button>
    );
};
